/**
 * Tronque un tag potentiellement incomplet en fin de buffer streaming.
 * Centralisation de la logique précédemment portée par cleanStreamingContent()
 * dans les deux MarkdownRenderer.
 *
 * Uniquement appelée si opts.streaming === true.
 */
const TRAILING_PARTIAL_RE = /<[^>]*$/;

export function partialStreamCut(text: string): string {
  if (!text) return text;
  return text.replace(TRAILING_PARTIAL_RE, '');
}
